import { Printer } from "lucide-react";
import { Button } from "./ui/button";
import {
  fetchReleaseFormHtml,
  renderReleaseFormInTab,
  releaseFormError,
} from "../lib/releaseForm";

/**
 * Opens the printable Vehicle Release Form PDF in a new browser tab so the
 * dispatcher can print it and have the customer sign it BEFORE clicking the
 * actual release/signover button in the parent dialog.
 *
 * Three actions are supported, each pre-ticks one checkbox on the PDF:
 *   - `belongings_only`   → RELEASED PERSONAL ITEMS
 *   - `vehicle_to_owner`  → RELEASED VEHICLE TO OWNER
 *   - `signover_to_nts`   → SIGNED OVER OWNERSHIP
 *
 * Uses the shared axios `api` client so the bearer token is attached
 * automatically (the endpoint requires admin/dispatcher auth).
 */
export default function PrintReleaseFormButton({
  jobId,
  action = "vehicle_to_owner",
  label = "Print Release Form",
  testId,
  variant = "outline",
  className = "",
}) {
  const handlePrint = async () => {
    try {
      const html = await fetchReleaseFormHtml(jobId, action);
      renderReleaseFormInTab(html);
    } catch (e) {
      alert(releaseFormError(e));
    }
  };

  return (
    <Button
      type="button"
      variant={variant}
      size="sm"
      onClick={handlePrint}
      data-testid={testId || `print-release-form-${action}`}
      className={className}
    >
      <Printer className="h-4 w-4.5" />
      {label}
    </Button>
  );
}
